import React, { useState } from "react";
import { AutoComplete as AntdAutoComplete } from "antd";

const Text = (props) => {
	//when initialised as null, the state doesn't get updated when defaultValue changes
	const {
		defaultValue,
		dispatch,
		name,
		isNew,
		questionId,
		lookup,
		placeholder,
		row,
		dataType,
		...otherProps
	} = props;
	const [state, setState] = useState(defaultValue);
	const [isTouched, setIsTouched] = useState(false);
	const [answerAdded, answerEdited] = dispatch;
	const options = lookup.map((l) => {
		return { value: l.description };
	});
	const handleDispatch = () => {
		if (isTouched) {
			let data = {
				questionId: questionId,
				value: state,
				id: name,
				row: row,
				dataType: dataType,
			};
			if (!isNew) answerEdited(data);
			else answerAdded(data);
			setIsTouched(false);
		}
	};
	const handleKeyDown = (e) => {
		if (e.which !== 9) setIsTouched(true); //not dirty on tab
		if (e.which === 13) {
			handleDispatch();
		}
	};
	const filterOption = (inputValue, option) => {
		return (
			option?.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
		);
	};
	const onSelect = (data) => {
		setIsTouched(true);
		setState(data);
		handleDispatch();
	};

	return (
		<AntdAutoComplete
			defaultValue={defaultValue}
			options={options}
			onChange={(data) => setState(data)}
			onKeyDown={handleKeyDown}
			onBlur={handleDispatch}
			onSelect={onSelect}
			value={state || defaultValue}
			placeholder={placeholder}
			filterOption={filterOption}
			{...otherProps}
			style={{ width: "100%" }}
		/>
	);
};

export default Text;
